import React, { useState } from 'react';

const AdminAddProduct = () => {
  // 1. تحديث الـ state ليشمل الحقول الجديدة
  const [product, setProduct] = useState({
    name_ar: '', name_en: '', price: '', 
    image_url: '', description_ar: '', description_en: '',
    brand_en: '', brand_ar: '' // الحقول الجديدة
  });
  const [message, setMessage] = useState('');

  // مصفوفة الماركات لسهولة الاختيار
  const brands = [
    { name: 'Baseel', ar: 'بسيل' },
    { name: 'Rghawy', ar: 'رغاوي' },
    { name: 'XClor', ar: 'إكس كلور' },
    { name: 'Mival', ar: 'ميفال' },
    { name: 'Tany', ar: 'تاني' },
    { name: 'C-Plus', ar: 'سي بلاس' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // تأكد من اختيار الماركة
    if (!product.brand_en) {
      setMessage('⚠️ من فضلك اختر الماركة');
      return;
    }

    try {
      const response = await fetch('https://www.yam-ii.com/yam_api/add_product.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(product)
      });
      const data = await response.json();
      if (data.status === 'success') {
        setMessage('✅ تم إضافة المنتج بنجاح!');
        // إعادة تعيين النموذج
        setProduct({ 
          name_ar: '', name_en: '', price: '', 
          image_url: '', description_ar: '', description_en: '',
          brand_en: '', brand_ar: '' 
        });
      } else {
        setMessage('❌ فشل الإضافة: ' + data.message);
      }
    } catch (error) {
      setMessage('❌ خطأ في الاتصال بالسيرفر');
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h3>➕ إضافة منتج جديد</h3>
        {message && <p style={{ color: message.includes('✅') ? 'green' : 'red', fontWeight: 'bold' }}>{message}</p>}
        
        {/* حقل اختيار الماركة - مهم جداً */}
        <select 
          style={styles.input} 
          required 
          value={product.brand_en} 
          onChange={e => {
            const selectedBrand = brands.find(b => b.name === e.target.value);
            setProduct({
              ...product, 
              brand_en: selectedBrand.name, 
              brand_ar: selectedBrand.ar
            });
          }}
        >
          <option value="">-- اختر الماركة --</option>
          {brands.map((b, index) => (
            <option key={index} value={b.name}>{b.ar} ({b.name})</option>
          ))}
        </select>

        <input type="text" placeholder="الاسم بالعربي" style={styles.input} required value={product.name_ar} onChange={e => setProduct({...product, name_ar: e.target.value})} />
        <input type="text" placeholder="Name in English" style={styles.input} required value={product.name_en} onChange={e => setProduct({...product, name_en: e.target.value})} />
        <input type="number" placeholder="السعر" style={styles.input} required value={product.price} onChange={e => setProduct({...product, price: e.target.value})} />
        <input type="text" placeholder="اسم ملف الصورة (مثال: product1.jpg)" style={styles.input} required value={product.image_url} onChange={e => setProduct({...product, image_url: e.target.value})} />
        <textarea placeholder="الوصف بالعربي" style={styles.input} value={product.description_ar} onChange={e => setProduct({...product, description_ar: e.target.value})} />
        <textarea placeholder="Description in English" style={styles.input} value={product.description_en} onChange={e => setProduct({...product, description_en: e.target.value})} />
        
        <button type="submit" style={styles.btn}>حفظ المنتج</button>
        <button type="button" onClick={() => window.location.href='/admin-dashboard'} style={{...styles.btn, background: '#777'}}>العودة للوحة التحكم</button>
      </form>
    </div>
  );
};

// ... (نفس الـ styles السابقة)
const styles = {
  container: { display: 'flex', justifyContent: 'center', padding: '50px', background: '#f4f4f4', minHeight: '100vh' },
  form: { background: '#fff', padding: '30px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', width: '400px', display: 'flex', flexDirection: 'column', gap: '15px' },
  input: { padding: '10px', borderRadius: '5px', border: '1px solid #ddd', fontSize: '1rem', outline: 'none' },
  btn: { padding: '12px', background: '#d4af37', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }
};

export default AdminAddProduct;